import { createContext, useContext, useMemo, type ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { getPublicSearchIndexData } from "@/lib/api/public.functions";
import { buildSearchIndex, type Hit, type SearchIndexInput } from "./SearchIndex";

const SearchIndexContext = createContext<Hit[] | null>(null);

export function SearchIndexProvider({
  data: initialData,
  children,
}: {
  data: SearchIndexInput;
  children: ReactNode;
}) {
  const { data = initialData } = useQuery({
    queryKey: ["public-search-index"],
    queryFn: () => getPublicSearchIndexData(),
    initialData,
    staleTime: 30_000,
    refetchOnMount: false,
    refetchOnWindowFocus: true,
  });

  const { services, insights, stories, leaders, careers, firmContact } = data;
  const index = useMemo(
    () => buildSearchIndex({ services, insights, stories, leaders, careers, firmContact }),
    [services, insights, stories, leaders, careers, firmContact],
  );

  return <SearchIndexContext.Provider value={index}>{children}</SearchIndexContext.Provider>;
}

export function useSearchIndex(): Hit[] {
  const index = useContext(SearchIndexContext);
  return index ?? buildSearchIndex();
}
